
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 135579","transform":"translate(-1336 -196)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(1336 196)","fill":"#fa4798","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135573"}},[_c('g',{attrs:{"fill":"none","stroke":"#fa4798","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/wallet-minus"}},[_c('path',{attrs:{"d":"M1361.638 224.664h-5.833","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1359.77 208.933l-.035.086-3.383 7.852h-3.325a5.734 5.734 0 00-2.24.455l2.042-4.877.046-.116.082-.187a1.009 1.009 0 01.082-.2c1.528-3.534 3.255-4.339 6.731-3.013zM1366.059 217.105a5.553 5.553 0 00-1.645-.233h-8.062l3.383-7.852.035-.082c.175.058.338.14.513.21l2.579 1.09a7.579 7.579 0 013.045 1.96 2.468 2.468 0 01.292.42 1.775 1.775 0 01.233.5 1.884 1.884 0 01.105.3 5.516 5.516 0 01-.478 3.687z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1370.109 222.564v2.275c0 .233-.012.467-.023.7-.222 4.072-2.5 6.125-6.813 6.125h-9.1a6.439 6.439 0 01-.826-.058q-5.568-.367-5.942-5.935a6.439 6.439 0 01-.058-.832v-2.275a5.709 5.709 0 013.453-5.238 5.777 5.777 0 012.24-.455h11.387a5.839 5.839 0 011.645.233 5.721 5.721 0 014.037 5.46z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1352.828 212.449l-2.042 4.877a5.709 5.709 0 00-3.453 5.238v-3.415a6.823 6.823 0 015.495-6.7zM1370.105 219.146v3.418a5.692 5.692 0 00-4.037-5.45 5.713 5.713 0 00.49-3.7 1.333 1.333 0 00-.105-.3 6.793 6.793 0 013.652 6.032z","opacity":".4"}})])])])])
          )
        }
      }
    